import OfflineBoundary from './OfflineBoundary.tsx';
import PWABadge from './PWABadge.tsx';
import * as Sentry from '@sentry/react';
import axios from './app/api-client.ts';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import './_mesomb/assets/sass/pay.scss';
import i18n from './_mesomb/i18n';
import { setupAxios } from './app/modules/auth';
import App from './pay/App.tsx';
import {ChunkErrorBoundary} from "./ChunkErrorBoundary.tsx";

setupAxios(axios);
//
// if (store.getState().auth?.user?.locale) {
//   i18n.changeLanguage(store.getState().auth?.user?.locale);
// }

// import('./firebase.ts').then(({initialize}) => {
//   initialize()
// });

// (function(w,d,t,u,n,a,m){w['MauticTrackingObject']=n;
//   w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments)},a=d.createElement(t),
//     m=d.getElementsByTagName(t)[0];a.async=1;a.src=u;m.parentNode.insertBefore(a,m)
// })(window, document,'script', `${import.meta.env.VITE_APP_ENVIRONMENT == 'development' ? 'http://mautic.vig/index.php' : 'https://marketing.hachther.com'}/mtc.js`,'mt');
const container = document.getElementById('root');
if (container) {
  createRoot(container, {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    // onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    //   console.warn('Uncaught error', error, errorInfo.componentStack);
    // }),
    // Callback called when React catches an error in an ErrorBoundary.
    // onCaughtError: Sentry.reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler(),
  }).render(
    <I18nextProvider i18n={i18n} defaultNS={'translation'}>
      <OfflineBoundary>
        <ChunkErrorBoundary>
          <App />
        </ChunkErrorBoundary>
        <PWABadge />
      </OfflineBoundary>
    </I18nextProvider>
  );
}

// register();
